// MO4.1.3
// TierPromotionCard the smartest - is aware of business logic and picks which CTA button to show
import React from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import TierPromotionCardSemiDumb, {
  Props as TierPromotionCardSemiDumbProps,
} from '../TierPromotionCardSemiDumb';
import { useTierPromotionCardCtaType } from './useTierPromotionCardCtaType';
import s from './TierPromotionCard.scss';

export type Props = Pick<
  TierPromotionCardSemiDumbProps,
  | 'width'
  | 'height'
  | 'className'
  | 'ctaClassname'
  | 'ctaWrapperClassName'
  | 'wrapperClassName'
  | 'showEmptyPlaceholders'
  | 'showAuthor'
  | 'style'
  | 'hotspot'
  | 'innerRef'
> & {
  deviation: PapiDeviation;
  fakeCTAButton?: boolean;
  verticalLayout?: boolean;
  onClick?: (deviation: PapiDeviation) => void;
};

const TierPromotionCard: React.FC<Props> = ({
  deviation,
  onClick,
  ctaClassname,
  fakeCTAButton,
  verticalLayout,
  ...props
}) => {
  const ctaButton = useTierPromotionCardCtaType(deviation);

  if (!deviation.tier) {
    return null;
  }

  return (
    <TierPromotionCardSemiDumb
      deviation={deviation}
      onClick={() => onClick && onClick(deviation)}
      ctaButton={ctaButton}
      ctaClassname={c(ctaClassname, fakeCTAButton && s['fake-button'])}
      verticalLayout={verticalLayout}
      {...props}
    />
  );
};
TierPromotionCard.displayName = 'TierPromotionCard';

export default TierPromotionCard;
